import React from 'react'
import instagramIcon from '../images/every-social-media-logo-and-icon-in-one-handy-place-instagram.png'
import facebookIcon from '../images/sm-icons-facebook-logo.png'
import spotifyIcon from '../images/Spotify_Primary_Logo_RGB_Green.png'
import youtubeIcon from '../images/sm-icons-youtube.png'
import venmoIcon from '../images/Venmo_Monogram.png'
import discordIcon from '../images/icon_clyde_blurple_RGB.png'

const Social_Media = () => {
  return (
    <div class="social_media_div">

      <div class="social_media_links">
        {/* big links  */}
        <h1 className="links_big">
          Social Media
        </h1>
        <h1 className="links_small">
          Socials
        </h1>
        <div class="centering_icons">
          <a href="https://www.instagram.com/washington.wrestling.network" target="_blank" rel="noopener noreferrer">
            <img class="social_icon" src={instagramIcon} alt="" />
          </a>
          <a href="https://www.facebook.com/washingtonwrestlingnetwork" target="_blank" rel="noopener noreferrer">
            <img class="social_icon" src={facebookIcon} alt="" />
          </a>
        </div>
        <div class="centering_icons">
          <a href="https://open.spotify.com/show/33kjRpgGG0EOLtJXoaVHHB?si=13d807caebab4566" target="_blank" rel="noopener noreferrer">
            <img class="social_icon spotify_icon" src={spotifyIcon} alt="" />
          </a>
          <a href="https://www.youtube.com/@washingtonwrestlingnetwork" target="_blank" rel="noopener noreferrer">
            <img class="social_icon youtube_icon" src={youtubeIcon} alt="" />
          </a>
        </div>
        <a href="https://discord.gg/ZxNHXwjmqw" target="_blank" rel="noopener noreferrer">
          <img class="social_icon youtube_icon" src={discordIcon} alt="" />
        </a>
      </div>
      
      <div class="donate_link">
        <h1 className="links_big">Donate</h1>
        <h1 className="links_small">Donate</h1>
        <a href="https://account.venmo.com/u/washington_wrestling_network" target="_blank" rel="noopener noreferrer">
          <img class="social_icon" src={venmoIcon} alt="" />
        </a>
      </div>
    </div>
  )
}

export default Social_Media